module.exports = __webpack_public_path__ + "static/media/aaa_blank.4df973ef.png";